import {IMetricViewMetric, IPlanMetric, IPlanMetricView, IPlanMetricViewProvider} from "./PA.UIM.TPM.IF";

import * as _ from 'lodash'
import {PASearch} from "../PA.Core/PASearch";
import {GenericLease} from "../PA.Utils/GenericLease";
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";

const dctPlanMetricView: { views: { [id: string]: IPlanMetricView } } = {views: {}}
const aLease = new GenericLease(LeaseRegistry.Lease_Type_MetricView)
const status: { isCacheLoaded: boolean } = {isCacheLoaded: false}


const PlanMetricViewProvider: IPlanMetricViewProvider = {
    LoadPlanMetricViews(): Promise<IPlanMetricView[]> {
        let returnValue: IPlanMetricView[] = []
        let aViewId: string = ''
        let arrPlanMetrics: IPlanMetric[] = []
        let aPlanView: IPlanMetricView = undefined
        return new Promise<IPlanMetricView[]>((resolve, error) => {
            PASearch.find("vUI_WB_Metric_View_Metrics", {}, {}, [], 0, [])
                .then((results: IMetricViewMetric[]) => {
                    if (_.isEmpty(results)) {
                        resolve()
                    }
                    _.forEach(results, (aRow: IMetricViewMetric) => {
                        if (aRow.METRIC_VIEW_ID != aViewId) {
                            if (arrPlanMetrics.length) {
                                aPlanView.PlanMetrics = arrPlanMetrics
                                dctPlanMetricView.views[aPlanView.id] = aPlanView
                                returnValue.push(aPlanView)
                            }
                            arrPlanMetrics = []
                            aPlanView = {
                                id: aRow.METRIC_VIEW_ID,
                                name: aRow.METRIC_VIEW_NAME,
                                sort_order: aRow.VIWEORDER,
                                renderOptions: !_.isEmpty(aRow.VIEWRENDEROPTIONS) ? JSON.parse(aRow.VIEWRENDEROPTIONS) : {},
                                PlanMetrics: arrPlanMetrics
                            }
                            aViewId = aRow.METRIC_VIEW_ID
                        }
                        let aPlanMetric: IPlanMetric = {
                            id: aRow.METRIC_ID,
                            name: aRow.METRIC_NAME,
                            type: aRow.METRIC_DATATYPE,
                            copyPolicy: aRow.COPYPOLICY == "1",
                            editable: aRow.EDITABLE_IND == "1",
                            totalPolicy: aRow.TOTALPOLICY == "1",
                            formula: aRow.FORMULA,
                            format: JSON.parse(aRow.METRIC_FORMAT),
                            recordPropertyNames: aRow.RECORD_PROPERTIES.split(","),
                            renderOptions: !_.isEmpty(aRow.METRICRENDEROPTIONS) ? JSON.parse(aRow.METRICRENDEROPTIONS) : {},
                            minValue: aRow.MINVALUE,
                            maxValue: aRow.MAXVALUE
                        }
                        if (!_.isEmpty(aRow.TOTAL_AGGREGATION_TERMS)) {
                            const aggregateTermMap: { [key: string]: any } = {}
                            const termList = aRow.TOTAL_AGGREGATION_TERMS.split(/\r?\n/)
                            _.forEach(termList, (term) => {
                                let [key, body] = term.split(':').map(seg => seg.trim())
                                if (_.isEmpty(body)) {
                                    // for one-line functions, only a function body is defined. Use a default key "A"
                                    body = key
                                    key = "A"
                                }
                                aggregateTermMap[key] = new Function("aRow", "return " + body + ";") as any
                            })
                            aPlanMetric.aggregateTerms = aggregateTermMap
                            aPlanMetric.totalFormula = aRow.TOTAL_FORMULA
                        }
                        arrPlanMetrics.push(aPlanMetric)

                    })
                    if (arrPlanMetrics.length) {
                        aPlanView.PlanMetrics = arrPlanMetrics
                        dctPlanMetricView.views[aPlanView.id] = aPlanView
                        returnValue.push(aPlanView)
                    }
                    status.isCacheLoaded = true
                    resolve(returnValue)
                })

                .catch((err) => {
                    error(err)
                })

        })
    },

    getPlanMetricViews(arrPlanViewIds: string[]): Promise<IPlanMetricView[]> {
        return new Promise<IPlanMetricView[]>((resolve, error) => {
            let arrView: IPlanMetricView[] = []
            if (aLease.hasDataChanged()) {
                status.isCacheLoaded = false
                dctPlanMetricView.views = {}
                aLease.resetLease()
            }

            if (!status.isCacheLoaded) {
                this.LoadPlanMetricViews()
                    .then(() => {
                        _.forEach(arrPlanViewIds, anId => {
                            if (!_.isEmpty(dctPlanMetricView.views[anId]))
                                arrView.push(dctPlanMetricView.views[anId])
                        })

                        resolve(arrView)
                    })
            } else {
                _.forEach(arrPlanViewIds, anId => {
                    arrView.push(dctPlanMetricView.views[anId])
                })

                resolve(arrView)
            }
        })
    }
}

export {PlanMetricViewProvider}